var React = require('react');

function PhoneLaptopDuotone (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"fa-group"},[React.createElement("path",{"className":"fa-secondary","fill":"currentColor","d":"M128 64h320v32h64V48a48.1 48.1 0 0 0-47.91-48H111.91A48.1 48.1 0 0 0 64 48v240H16a16 16 0 0 0-16 16v16a64.14 64.14 0 0 0 63.91 64H352v-96H128z","opacity":"0.4","key":0}),React.createElement("path",{"className":"fa-primary","fill":"currentColor","d":"M604 128H420a36 36 0 0 0-36 36v312a36 36 0 0 0 36 36h184a36 36 0 0 0 36-36V164a36 36 0 0 0-36-36zm-28 320H448V192h128z","key":1})]));
}

PhoneLaptopDuotone.defaultProps = {"aria-hidden":"true","focusable":"false","viewBox":"0 0 640 512"};

module.exports = PhoneLaptopDuotone;

PhoneLaptopDuotone.default = PhoneLaptopDuotone;
